exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".diff{font-weight:700}", "", {"version":3,"sources":["/var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/reservations/reservation-detail-table/reservation-detail-table.component.css"],"names":[],"mappings":"AAAA,MACE,eAAkB,CACnB","file":"reservation-detail-table.component.css","sourcesContent":[".diff {\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/reservations/reservation-detail-table/reservation-detail-table.component.css
// module id = oP5S
// module chunks = 0